import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    filterProp: Object,
  },
  components: {},
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      costs: [],
      expanded: [],
      serviceOrderTypes: [
        'Treinamento',
        'Segurança elétrica',
        'Preventiva',
        'Instalação',
        'Rotina de Inspeção',
        'Corretiva',
        'Calibração',
        'Validação/Qualificação',
        'Serviço Administrativo',
        'Empréstimo',
      ],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'O.S.',
          align: 'center',
          value: 'os',
        },
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'OSTipo',
        },
        {
          text: 'Nº Identificação',
          align: 'center',
          value: 'numIdent',
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'equipamento',
        },
        {
          text: 'Descrição',
          align: 'center',
          value: 'descricao',
        },
        {
          text: 'Custo',
          align: 'center',
          value: 'valor',
        },
      ],
      headerMobile: [
        {
          text: 'O.S',
          align: 'center',
          value: 'os',
        },
        {
          text: 'Custo',
          align: 'center',
          value: 'valor',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listCostPerPiece()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `cost_Single_Piece_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/costSinglePiece', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listCostPerPiece() {
      await this.apiService
        .post('reports/listCostsSinglePiece', this.filterProp)
        .then((response) => {
          this.total = response.content.total
          this.costs = []
          this.showChart = response.content.model.objects.length > 0
          this.costs = response.content.model.objects
          this.totalPages = response.content.model.pager.totalPages
        })
        .catch((err) => {})
    },
    formatCurrency(value) {
      const stringValue = value.toFixed(2)
      const parts = stringValue.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return `$${parts.join(',')}`
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listCostPerPiece()
    },
  },
}
